import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner";
import { getPlayerData } from "../api/dataSource";

export default function Players() {
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getPlayerData();
      setPlayers(data);
    };
    fetchData();
  }, []);

  return (
    <>
      <PageBanner
        title="Players"
        subtitle="Meet our talented chess players from Ranipet District"
        image="/images/chess.png"
      />
      
      <section className="py-12 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Improved Page Heading Section */}
          <div className="mb-8 sm:mb-16 text-center sm:text-left">
            <Link
              to="/players/register"
              className="bg-yellow-500 hover:bg-yellow-600 
                         text-blue-900 font-semibold px-4 sm:px-6 py-2 sm:py-3 
                         rounded-lg sm:rounded-xl shadow-md transition-all inline-block"
            >
              + Register New Player
            </Link>
          </div>
          
          {/* Improved Grid Layout - Better mobile responsiveness */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 lg:gap-10">
            {players && players.length > 0 ? (
              players.map(player => (
                <div
                  key={player.id}
                  className="group bg-white rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-2xl 
                             transition-all duration-500 overflow-hidden hover:ring-2 sm:hover:ring-4 hover:ring-yellow-300"
                >
                  {/* Image Section */}
                  <div className="relative">
                    <img
                      src={player.photo || `/images/p${player.id}.jpg`}
                      alt={player.name}
                      className="w-full h-80 sm:h-72 md:h-80 object-cover object-[50%_20%]
                                 group-hover:scale-110 transition-transform duration-700"
                      onError={(e) => {
                        // Try jpg first, then png, then webp
                        const extensions = ['.jpg', '.png', '.webp'];
                        let tried = 0;
                        
                        const tryNextExtension = () => {
                          if (tried < extensions.length) {
                            e.currentTarget.src = `/images/p${player.id}${extensions[tried]}`;
                            tried++;
                          }
                        };
                        
                        tryNextExtension();
                      }}
                    />

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t 
                                    from-black/70 via-transparent to-transparent"></div>

                    {/* Badge */}
                    <span className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-yellow-400 
                                     text-blue-900 text-xs font-bold px-2 py-1 sm:px-3 sm:py-1 
                                     rounded-full shadow">
                      RDCA
                    </span>
                  </div>

                  {/* Info */}
                  <div className="p-3 sm:p-4 text-center">
                    <h3 className="text-base sm:text-lg font-bold text-gray-800">
                      {player.name}
                    </h3>
                    <p className="text-xs sm:text-sm text-gray-500 mt-1">
                      Ranipet District Chess Academy
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center py-12">
                <p className="text-gray-500 text-lg">Loading players...</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}